// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-c[data-v-bf1bdd5a]{font-weight:500;color:#fff;border-radius:0px}.btn-c.add[data-v-bf1bdd5a]{background-color:#1ad596;border-color:#1ad596}.btn-c.delete[data-v-bf1bdd5a]{background-color:#dc3545;border-color:#dc3545}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
